import {connect} from 'react-redux'
import AnalysisPanel from '../components/analysis-page/analysis-panel'
import * as analysisActions from '../store/analysis/actions'
import * as appActions from '../store/app/actions'

function mapStateToProps (state) {
  return {
    ...state.analysis,
    ...state.app,
  }
}

export default connect(mapStateToProps, {...analysisActions, ...appActions})(AnalysisPanel)



// WEBPACK FOOTER //
// ./src/containers/analysis-panel-container.js